import React, {Component} from 'react';
import {Modal, FormControl, FormGroup, ControlLabel, Row, Col} from 'react-bootstrap';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import _ from 'lodash';
import ImageCropper from './services/ImageCropper';
import avatar from '../../../../../../images/face-0.jpg';
import './styles.css';
import Select from 'react-select/lib/Creatable';
import {components} from 'react-select';
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";

const days = [], years = [],
    months = [{value: '1', label: 'enero'}, {value: '2', label: 'febrero'}, {value: '3', label: 'marzo'}, {
        value: '4',
        label: 'abril'
    }, {value: '5', label: 'mayo'}, {value: '6', label: 'junio'}, {value: '7', label: 'julio'}, {
        value: '8',
        label: 'agosto'
    }, {value: '9', label: 'septiembre'}, {value: '10', label: 'octubre'}, {
        value: '11',
        label: 'noviembre'
    }, {value: '12', label: 'diciembre'}];
const minOffset = 0, maxOffset = 80;
const thisYear = (new Date()).getFullYear();

for (let i = minOffset; i <= maxOffset; i++) {
    years.push({value: thisYear - i, label: thisYear - i})
}

for (let i = 1; i <= 31; i++) {
    days.push({value: i, label: i})
}

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <i className="fa fa-angle-down"></i>
        </components.DropdownIndicator>
    );
};

class PersonFormModal extends Component {

    static contextTypes = {api: PropTypes.object, notifier: PropTypes.object};

    constructor(props, context) {
        super(props);

        if (props.defaultValues) {
            context.api.people.getById(props.defaultValues.id).then((data) => {
                this.setState({form: PersonFormModal.entityToForm(data), photoUrl: props.photoUrl, loaded: true});
            })
        } else
            this.state = {form: {}, loaded: true};


        context.api.specialties.get(0, 200);
        context.api.fiscalRegimes.get(0,200);
        this.context = context;

    }

    /* --- Data treatment methods --- */

    static entityToForm(entity = {}) {

        const form = {...entity};
        delete form.membership.unwantedIHSYears;

        if (entity.residence) {

            if (_.find(estados, (est) => est === entity.residence)) {
                form.country = 'México';
                form.state = entity.residence;
            } else
                form.country = entity.residence;

        }

        if (entity.membership) {
            form.ihsMemberNumber = entity.membership.ihsMemberNumber;
            form.registrationDate = moment(entity.membership.registrationDate);
            form.type = entity.membership.type;
        }

        if (entity.specialty)
            form.specialty = {id: entity.specialty.id, value: entity.specialty.name, label: entity.specialty.name};

        if (entity.fiscalRegime)
            form.fiscalRegime = {id: entity.fiscalRegime.id, value: entity.fiscalRegime.name, label: entity.fiscalRegime.name};

        if (entity.mailerTags) {
            let tags = [];
            for (let i = 0; i < entity.mailerTags.length; i++) {
                tags.push(entity.mailerTags[i].id);
            }
            form.mailerTags = tags;
        }

        let memberBirthdate = new Date(entity.birthDate);
        if (entity.birthDate) {
            let day = memberBirthdate.getDate();
            let month = memberBirthdate.getMonth();
            let year = memberBirthdate.getFullYear();
            form.day = {value: day, label: day};
            form.month = months[month];
            form.year = {value: year, label: year}
        }

        let memberDateOfDeath = new Date(entity.dateOfDeath);
        if(entity.dateOfDeath){
            form.deathDay = {value: memberDateOfDeath.getDate(), label: memberDateOfDeath.getDate()};
            form.deathMonth = months[memberDateOfDeath.getMonth()];
            form.deathYear = {value: memberDateOfDeath.getFullYear(), label: memberDateOfDeath.getFullYear()}
            form.isAlive = "no";
        }
        return form;
    }

    static formToEntity(form) {

        const entity = {...form};

        //Create residence string
        if (form.country === 'México' && form.state)
            entity.residence = form.state;
        else if (form.country)
            entity.residence = form.country;
        else
            entity.residence = '';

        //Restore membership entity
        if (form.registrationDate || form.type) {
            entity.membership = entity.membership || {};
            if (form.registrationDate)
                entity.membership.registrationDate = form.registrationDate.format('YYYY-MM-DD');
            entity.membership.type = form.type || '';
            entity.membership.ihsMemberNumber=form.ihsMemberNumber;
        }

        //Create or set specialty
        if (form.specialty) {
            if (form.specialty.id)
                entity.specialty = "" + form.specialty.id;
            else if (form.specialty.__isNew__)
                entity.specialty = {name: form.specialty.value.toUpperCase()};
        }
        if (form.fiscalRegime) {
            if (form.fiscalRegime.id)
                entity.fiscalRegime= "" + form.fiscalRegime.id;
        }
        return entity;
    }

    /* --- Form Methods --- */

    onFormChange = ({target}) => {

        const form = {...this.state.form, [target.name]: target.value};
        this.setState({form});
    };

    onFormChangeCaps = ({target}) => {

        const form = {...this.state.form, [target.name]: target.value.toUpperCase()};
        this.setState({form});
    };

    getFormValue = (name) => {
        return this.state.form[name] ? this.state.form[name] : '';
    };

    onRegistrationFileSelect = (e) => {
        const files = e.target.files;
        if (!files || !files.length)
            return;

        this.setState({
            registrationFile: files[0]
        });
    };

    onAcademicResumeFileSelect = (e) => {
        const files = e.target.files;
        if (!files || !files.length)
            return;

        this.setState({
            academicResumeFile: files[0]
        });
    };

    onSubmit = (e) => {
        e.preventDefault();
        let date, deathDate = null
        if (this.state.form.year && this.state.form.month && this.state.form.day)
            date = moment(this.state.form.year.value + '-' + this.state.form.month.value + '-' + this.state.form.day.value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (date === "Invalid date") return this.context.notifier.error("Fecha de nacimiento inválida, favor de corregir");

        if (this.state.form.isAlive==="no" && this.state.form.deathYear && this.state.form.deathMonth && this.state.form.deathDay)
            deathDate = moment(this.state.form.deathYear.value + '-' + this.state.form.deathMonth.value + '-' + this.state.form.deathDay.value, 'YYYY-MM-DD').format('YYYY-MM-DD');

        this.setState({form: {...this.state.form,  birthDate: date, dateOfDeath: deathDate}}, () => {
            if (this.props.onSubmit)
                this.props.onSubmit(PersonFormModal.formToEntity(this.state.form), this.state.photo, this.state.registrationFile, this.state.academicResumeFile);
        });
    };


    /* --- Photo Methods --- */

    photoButton = () => {

        const imgCropper = new ImageCropper();
        imgCropper.setImage(this.webcam.getScreenshot())
            .then((img) => img.getSquare())
            .then((square) => {
                this.setState({
                    photo: square,
                    photoUrl: this.getPhotoUrl(square),
                    cameraActive: false
                });

            });

    };

    getPhotoUrl(photo) {

        if (!photo)
            return "";

        let urlCreator = window.URL || window.webkitURL;
        return urlCreator.createObjectURL(photo);
    }

    onPhotoSelect = (e) => {
        const files = e.target.files;
        if (!files || !files.length)
            return;


        if (FileReader && files && files.length) {
            const fr = new FileReader();
            fr.onload = () => {
                this.setState({
                    photo: files[0],
                    photoUrl: fr.result
                });
            };
            fr.readAsDataURL(files[0]);
        }
    };

    deleteSpecialty = (specialty, e) => {
        e.stopPropagation();
        this.context.api.specialties.delete(specialty.id);
    };


    render() {
        return (
            <Modal
                show={true}
                onHide={this.props.onHide}
                className='PersonFormModal'>

                {this.state && this.state.loaded ?
                    <form onSubmit={this.onSubmit}>

                        <Modal.Header closeButton>
                            <Modal.Title>{this.props.editing ? 'Editar' : 'Nuevo'} miembro</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <FormGroup controlId='name'>
                                <ControlLabel>* Nombre</ControlLabel>
                                <FormControl
                                    placeholder='Nombre'
                                    name='name'
                                    value={this.getFormValue('name')}
                                    onChange={this.onFormChangeCaps}
                                    required
                                />
                            </FormGroup>

                            <Row>
                                <Col md={6}>
                                    <FormGroup controlId='patLastName'>
                                        <ControlLabel>* Apellido paterno</ControlLabel>
                                        <FormControl
                                            placeholder='Apellido paterno'
                                            name='patLastName'
                                            value={this.getFormValue('patLastName')}
                                            onChange={this.onFormChangeCaps}
                                            required
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup controlId='matLastName'>
                                        <ControlLabel>Apellido materno</ControlLabel>
                                        <FormControl
                                            placeholder='Apellido materno'
                                            name='matLastName'
                                            value={this.getFormValue('matLastName')}
                                            onChange={this.onFormChangeCaps}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup controlId='birthdate'>
                                <ControlLabel>Fecha de nacimiento</ControlLabel>
                                <Row>
                                    <Col md={3} xs={3}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('day')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({target: {name: "day", value}})}
                                            options={days}
                                            placeholder="Día"
                                        />
                                    </Col>
                                    <Col md={5} xs={5}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('month')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({target: {name: "month", value}})}
                                            options={months}
                                            placeholder="Mes"
                                        />
                                    </Col>
                                    <Col md={4} xs={4}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('year')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({target: {name: "year", value}})}
                                            options={years}
                                            placeholder="Año"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup controlId='birthdate'>
                                <ControlLabel>¿El miembro se encuentra vivo?</ControlLabel>
                                <FormControl componentClass="select" name='isAlive' value={this.getFormValue('isAlive')}
                                             onChange={this.onFormChange} required>
                                    <option value='yes'>Si</option>
                                    <option value='no'>No</option>
                                </FormControl>
                            </FormGroup>
                            {this.state.form.isAlive === "no" &&

                            <FormGroup controlId='dateOfDeatch'>
                                <ControlLabel>Fecha de defunción</ControlLabel>
                                <Row>
                                    <Col md={3} xs={3}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('deathDay')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({target: {name: "deathDay", value}})}
                                            options={days}
                                            placeholder="Día"
                                        />
                                    </Col>
                                    <Col md={5} xs={5}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('deathMonth')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({
                                                target: {
                                                    name: "deathMonth",
                                                    value
                                                }
                                            })}
                                            options={months}
                                            placeholder="Mes"
                                        />
                                    </Col>
                                    <Col md={4} xs={4}>
                                        <Select
                                            components={{DropdownIndicator}}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            value={this.getFormValue('deathYear')}
                                            isSearchable={false}
                                            onChange={(value) => this.onFormChange({
                                                target: {
                                                    name: "deathYear",
                                                    value
                                                }
                                            })}
                                            options={years}
                                            placeholder="Año"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>

                            }
                            <FormGroup controlId='email'>
                                <ControlLabel>* Email</ControlLabel>
                                <FormControl
                                    placeholder='Correo electrónico'
                                    name='email'
                                    value={this.getFormValue('email')}
                                    onChange={this.onFormChange}
                                    type='email'
                                    required
                                />
                            </FormGroup>

                            <Row>

                                <Col md={6}>
                                    <FormGroup controlId='title'>
                                        <ControlLabel>Título</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            placeholder='Dr.'
                                            name='title'
                                            value={this.getFormValue('title')}
                                            onChange={this.onFormChangeCaps}
                                        >
                                            <option value="DR.">DR.</option>
                                            <option value="DRA.">DRA.</option>
                                        </FormControl>
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup controlId='gender'>
                                        <ControlLabel>* Género</ControlLabel>
                                        <FormControl componentClass="select" name='gender'
                                                     value={this.getFormValue('gender')} onChange={this.onFormChange}
                                                     required>

                                            <option value='' disabled>Selecciona el género</option>
                                            <option value='F'>Femenino</option>
                                            <option value='M'>Másculino</option>

                                        </FormControl>
                                    </FormGroup>
                                </Col>

                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup controlId='fixedPhone'>
                                        <ControlLabel>Teléfono fijo</ControlLabel>
                                        <FormControl
                                            placeholder='5544332211'
                                            name='fixedPhone'
                                            value={this.getFormValue('fixedPhone')}
                                            onChange={this.onFormChange}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup controlId='mobilePhone'>
                                        <ControlLabel>Teléfono celular</ControlLabel>
                                        <FormControl
                                            placeholder='5544332211'
                                            name='mobilePhone'
                                            value={this.getFormValue('mobilePhone')}
                                            onChange={this.onFormChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>

                                <Col md={6}>
                                    <FormGroup controlId='specialty'>
                                        <ControlLabel>Especialidad</ControlLabel>
                                        <Select
                                            placeholder='Neurólogo'
                                            className='specialty-select'
                                            noOptionsMessage={() => "Aún no existen especialidades"}
                                            formatCreateLabel={(val) => "Crear especialidad \"" + val + "\""}
                                            options={this.props.specialties.map((sp) => ({
                                                value: sp.name,
                                                label: sp.name,
                                                id: sp.id
                                            }))}
                                            onChange={(value) => this.onFormChange({
                                                target: {
                                                    name: "specialty",
                                                    value
                                                }
                                            })}
                                            value={this.getFormValue('specialty')}
                                            components={{
                                                Option: (props) => {
                                                    return <div
                                                        className={'select-option ' + (props.isSelected ? 'selected ' : '') + (props.data.__isNew__ ? 'new-option' : '')}
                                                        {...props.innerProps}>
                                                        {props.label}
                                                        <i className='fa fa-trash pull-right'
                                                           onClick={(e) => this.deleteSpecialty(props.data, e)}/>
                                                    </div>
                                                }
                                            }}
                                        />


                                    </FormGroup>
                                </Col>


                                {/* oscuro: #008aff claro: #dbecff */}

                                <Col md={6}>
                                    <FormGroup controlId='rfc'>
                                        <ControlLabel>RFC</ControlLabel>
                                        <FormControl
                                            placeholder='EIDE621222AJK'
                                            name='rfc'
                                            value={this.getFormValue('rfc')}
                                            onChange={this.onFormChangeCaps}
                                        />
                                    </FormGroup>
                                </Col>


                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup controlId="fiscalRegime">
                                        <ControlLabel>Régimen fiscal</ControlLabel>
                                        <Select
                                            placeholder='Régimen fiscal'
                                            className='specialty-select'
                                            noOptionsMessage={() => "Sin opciones"}
                                            options={this.props.fiscalRegimes.map((r) => ({
                                                value: r.id,
                                                label: r.name,
                                                id: r.id
                                            }))}
                                            onChange={(value) => this.onFormChange({
                                                target: {
                                                    name: "fiscalRegime",
                                                    value
                                                }
                                            })}
                                            value={this.getFormValue('fiscalRegime')}

                                        />


                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup controlId='professionalLicense'>
                                <ControlLabel>Cédula profesional</ControlLabel>
                                <FormControl
                                    name='professionalLicense'
                                    value={this.getFormValue('professionalLicense')}
                                    onChange={this.onFormChangeCaps}
                                />
                            </FormGroup>

                            <FormGroup controlId='certificationNumber'>
                                <ControlLabel>Número de certificación</ControlLabel>
                                <FormControl
                                    name='certificationNumber'
                                    value={this.getFormValue('certificationNumber')}
                                    onChange={this.onFormChangeCaps}
                                />
                            </FormGroup>

                            <ControlLabel>Residencia</ControlLabel>
                            <Row>
                                <Col md={6}>
                                    <FormGroup controlId='country'>
                                        <ControlLabel>País</ControlLabel>
                                        <FormControl componentClass="select" name='country'
                                                     value={this.getFormValue('country')} onChange={this.onFormChange}
                                        >

                                            <option value='' disabled>Selecciona el país</option>
                                            <option value='México'>México</option>
                                            <option value='Extranjero'>Extranjero</option>

                                        </FormControl>
                                    </FormGroup>

                                </Col>
                                <Col md={6}>
                                    <FormGroup controlId='zipCode'>
                                        <ControlLabel>Código postal</ControlLabel>
                                        <FormControl
                                            placeholder='03900'
                                            name='zipCode'
                                            value={this.getFormValue('zipCode')}
                                            onChange={this.onFormChange}
                                        />
                                    </FormGroup>
                                </Col>

                                {this.state.form.country === 'México' ?
                                    <React.Fragment>
                                        <Col md={6}>
                                            <FormGroup controlId='state'>
                                                <ControlLabel>* Estado</ControlLabel>
                                                <FormControl componentClass="select" name='state'
                                                             value={this.getFormValue('state')}
                                                             onChange={this.onFormChange}
                                                             required>

                                                    <option value=''>Selecciona un estado</option>
                                                    {estados.map((est) =>
                                                        <option value={est} key={est}>{est}</option>
                                                    )}

                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup controlId='state'>
                                                <ControlLabel>Ciudad</ControlLabel>
                                                <FormControl name='city' value={this.getFormValue('city')}
                                                             onChange={this.onFormChangeCaps} required/>
                                            </FormGroup>
                                        </Col>
                                    </React.Fragment>
                                    : null}

                            </Row>

                            <ControlLabel>Membresía</ControlLabel>
                            <Row>
                                <Col md={6}>
                                    <FormGroup controlId='registrationDate'>
                                        <ControlLabel>* Fecha de registro</ControlLabel>
                                        <Datepicker
                                            dropdownMode={'select'}
                                            className='form-control'
                                            selected={this.getFormValue('registrationDate') || null}
                                            onChange={(date) => this.onFormChange({
                                                target: {
                                                    name: 'registrationDate',
                                                    value: date
                                                }
                                            })}/>
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup controlId='type'>
                                        <ControlLabel>* Tipo de membresía</ControlLabel>
                                        <FormControl componentClass="select" name='type'
                                                     value={this.getFormValue('type')}
                                                     onChange={this.onFormChange}>

                                            <option value='' disabled>Selecciona un tipo de membresía</option>
                                            <option value='Miembro fundador'>Miembro fundador</option>
                                            <option value='Miembro fundador emérito'>Miembro fundador emérito</option>
                                            <option value='Miembro'>Miembro</option>
                                            <option value='Miembro asociado'>Miembro Asociado</option>
                                            <option value='Miembro honorario'>Miembro Honorario</option>
                                            <option value='Miembro emérito'>Miembro Emérito</option>

                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup controlId='certificationNumber'>
                                <ControlLabel>Número de miembro IHS</ControlLabel>
                                <FormControl
                                    name='ihsMemberNumber'
                                    value={this.getFormValue('ihsMemberNumber')}
                                    onChange={this.onFormChangeCaps}
                                />
                            </FormGroup>

                            <FormGroup controlId='contactData'>
                                <ControlLabel>Información pública de contacto</ControlLabel>
                                <textarea
                                    name='contactData'
                                    value={this.getFormValue('contactData')}
                                    onChange={this.onFormChange}
                                    className='form-control'
                                />
                            </FormGroup>

                            <FormGroup controlId='academicResumeFile'>
                                <ControlLabel>Información académica</ControlLabel>
                                <input
                                    name='academicResumeFile'
                                    type='file'
                                    onChange={this.onAcademicResumeFileSelect}
                                    className='form-control'
                                />
                            </FormGroup>

                            <FormGroup controlId='registrationFile'>
                                <ControlLabel>Escaneo de registro firmado</ControlLabel>
                                <input
                                    name='registrationFile'
                                    type='file'
                                    onChange={this.onRegistrationFileSelect}
                                    className='form-control'
                                />
                            </FormGroup>

                            <div className={"card-content form-video"}>
                                <div>
                                    <img src={this.state.photoUrl || avatar} alt="User"/>
                                    <div className='clearfix'/>
                                    <input type='file' onChange={this.onPhotoSelect}/>
                                </div>
                            </div>

                        </Modal.Body>

                        <Modal.Footer>
                            <button type='button' onClick={this.props.onHide}
                                    className='btn btn-danger pull-left'>Cancelar
                            </button>
                            <button type='submit' className='btn btn-success' disabled={this.props.disabled}>Guardar
                            </button>
                        </Modal.Footer>

                    </form> :
                    <h1>Cargando...</h1>
                }
            </Modal>
        );
    }
}


const mapStateToProps = ({api: {specialties = [], fiscalRegimes = []}}) => {
    return {specialties, fiscalRegimes}
};

export default connect(mapStateToProps)(PersonFormModal);

const estados = [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Chiapas',
    'Chihuahua',
    'Coahuila de Zaragoza',
    'Colima',
    'Ciudad de México',
    'Durango',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'México',
    'Michoacán de Ocampo',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'San Luis Potosí',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz de Ignacio de la Llave',
    'Yucatán',
    'Zacatecas'
];


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/People/components/PersonFormModal/index.js